import React from 'react';
import { TextField, makeStyles, Fab } from '@material-ui/core';
import CustomerList from './CustomerList';
import AddIcon from '@material-ui/icons/Add';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMERS } from './graphql/queries';
import useHandleAuthError from '../../utils/hooks/useHandleAuthError';
import QueryGuard from '../../Components/QueryGuard';
import { useNavigate } from 'react-router-dom';
import { Customer } from './types/types';

const useStyles = makeStyles((theme) => ({
  textField: {
    width: '100%',
    background: 'white',
    borderColor: 'white',
    marginBottom: '2rem'
  },
  grid: {
    textAlign: 'right'
  },
  fab: {
    position: 'fixed',
    bottom: '2rem',
    right: '2rem'
  }
}));

const Customers = () => {
  const navigate = useNavigate();
  const onError = useHandleAuthError();
  const { textField, fab } = useStyles();
  const [keyword, setKeyword] = React.useState<string>('');
  const { loading, error, data } = useQuery(GET_CUSTOMERS, { variables: { query: keyword }, onError });

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      setKeyword(e.target.value);
    }
  };

  return (
    <>
      <h1 className="my-6 text-3xl">Customers</h1>
      <Fab color="primary" onClick={() => navigate('/customers/new')} aria-label="add" className={fab}>
        <AddIcon />
      </Fab>
      <TextField
        id="inline-search"
        label="Search"
        placeholder="Search customers by email, first name, last name...."
        type="search"
        variant="outlined"
        name="search"
        onKeyPress={onKeyPress}
        className={textField}
        margin="normal"
      />
      <QueryGuard loading={loading} error={!!error} data={data?.customers}>
        <CustomerList customers={(data?.customers || []) as Customer[]} />
      </QueryGuard>
    </>
  );
};

export default Customers;
